import React from "react";
import PropTypes from "prop-types";

const defaultStyle = {
  float: "right",
  paddingTop: "0px",
  marginTop: "-5px",
  fontSize: "14px",
};

const FormCharacterLimit = ({ length, limit }) => {
  return (
    <span style={defaultStyle}>
      <b>
        {length} / {limit}
      </b>{" "}
      character limit
    </span>
  );
};

FormCharacterLimit.defaultProps = {
  length: 0,
  limit: 1000,
};

FormCharacterLimit.propTypes = {
  length: PropTypes.number,
  limit: PropTypes.number,
};

export default FormCharacterLimit;
